// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2OLDj","productName":"Table_productName__2b1GN"};